import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import {
  FieldWrapper,
  FormlyFieldConfig,
  FormlyFieldProps,
} from '@ngx-formly/core';
import { Avatar } from 'primeng/avatar';
import { Divider } from 'primeng/divider';
import { FORM_IMPORTS } from '../../_shared/_imports/form.import';

export interface CheckboxFieldProps extends FormlyFieldProps {
  type?: 'inline' | 'divided' | 'icon';
  reverse?: boolean;
  icon?: string;
  divider?: boolean;
}

@Component({
  selector: 'formly-wrapper-primeng-checkbox',
  standalone: true,
  imports: [CommonModule, ...FORM_IMPORTS, Divider, Avatar],
  template: `
    @switch (props.type) {
      @case ('icon') {
        <div class="p-field flex flex-col justify-items-center items-center">
          <div>
            <p-avatar
              [icon]="props.icon"
              severity="accent"
              size="xlarge"
              shape="circle"
            />
          </div>
          <div class="mb-2 -mt-[calc(var(--p-avatar-lg-icon-size)_/_2)]">
            <label [for]="id" [innerHTML]="props.label"></label>
          </div>
          <ng-container #fieldComponent></ng-container>
        </div>
      }
      @case ('divided') {
        <div class="p-field">
          <div
            class="flex gap-4 items-center w-[calc(100%_-_var(--p-toggleswitch-width)_-_0.5rem)]"
          >
            @if (props.icon) {
              <div class="flex gap-2 items-center">
                <div>
                  <p-avatar
                    [icon]="props.icon"
                    severity="accent"
                    size="xlarge"
                    shape="circle"
                  />
                </div>
                <div class="flex flex-col gap-2">
                  <div class="font-bold" [innerHTML]="props.label"></div>
                  <div class="text-sm" [innerHTML]="props.description"></div>
                </div>
              </div>
            } @else {
              <div [innerHTML]="props.label"></div>
            }
          </div>
          <div class="flex justify-between content-center gap-2">
            @if (props.divider ?? true) {
              <p-divider></p-divider>
            } @else {
              <div></div>
            }
            <ng-container #fieldComponent></ng-container>
          </div>
          @if (showError) {
            <small
              class="text-[var(--p-form-field-invalid-placeholder-color)] italic ml-[var(--p-inputtext-padding-x)]"
            >
              <formly-validation-message
                class="ui-message-text"
                [field]="field"
              ></formly-validation-message>
            </small>
          }
        </div>
      }
      @default {
        <div class="p-field">
          <div
            class="flex gap-2 justify-between items-center {{
              props.reverse ? 'flex-row-reverse' : ''
            }}"
          >
            @if (props.icon) {
              <div class="w-1/6">
                <span class="{{ props.icon }} text-4xl text-primary"></span>
              </div>
              <div class="w-5/6 px-4 flex flex-col gap-2">
                <div [innerHTML]="props.label"></div>
                <div class="text-sm" [innerHTML]="props.description"></div>
              </div>
            } @else {
              <div class="flex flex-col gap-2">
                <div [innerHTML]="props.label"></div>
                <div class="text-sm" [innerHTML]="props.description"></div>
              </div>
            }
            <ng-container #fieldComponent></ng-container>
          </div>
          @if (showError) {
            <small
              class="text-[var(--p-form-field-invalid-placeholder-color)] italic ml-[var(--p-inputtext-padding-x)]"
            >
              <formly-validation-message
                class="ui-message-text"
                [field]="field"
              ></formly-validation-message>
            </small>
          }
        </div>
      }
    }
  `,
})
export class CheckboxFormlyWrapper extends FieldWrapper<
  FormlyFieldConfig<CheckboxFieldProps>
> {}
